import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'
import { getLocale, setLocale } from '@/i18n'

Vue.use(Vuex)

const THEME_STORAGE_KEY = 'ehd.crm.themeMode'
const DEFAULT_THEME_MODE = 'light'

function normalizeThemeMode(mode) {
  return mode === 'dark' ? 'dark' : 'light'
}

function getStoredThemeMode() {
  return normalizeThemeMode(localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME_MODE)
}

function applyThemeMode(mode) {
  const next = normalizeThemeMode(mode)
  document.documentElement.dataset.theme = next
  document.documentElement.style.colorScheme = next
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    locale: getLocale(),
    themeMode: getStoredThemeMode(),
    userInfo: {
      userId: null,
      username: '',
      realName: '',
      roleCodes: [],
      permissions: []
    },
    menuTree: [],
    workbench: {
      badges: {},
      tasks: [],
      recentActivities: [],
      upcomingVisits: []
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      if (token) localStorage.setItem('token', token)
    },
    setLocale(state, locale) {
      state.locale = locale
    },
    setThemeMode(state, mode) {
      const next = normalizeThemeMode(mode)
      state.themeMode = next
      localStorage.setItem(THEME_STORAGE_KEY, next)
      applyThemeMode(next)
    },
    clearAuth(state) {
      state.token = ''
      localStorage.removeItem('token')
      state.locale = getLocale()
      state.userInfo = {
        userId: null,
        username: '',
        realName: '',
        roleCodes: [],
        permissions: []
      }
      state.menuTree = []
      state.workbench = {
        badges: {},
        tasks: [],
        recentActivities: [],
        upcomingVisits: []
      }
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setMenuTree(state, menuTree) {
      state.menuTree = menuTree || []
    },
    setWorkbench(state, workbench) {
      state.workbench = {
        badges: {},
        tasks: [],
        recentActivities: [],
        upcomingVisits: [],
        ...(workbench || {})
      }
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const resp = await request({
        url: '/login',
        method: 'post',
        data: { username, password }
      })

      if (!resp || resp.code !== 200) {
        throw new Error(resp && resp.msg ? resp.msg : 'Login failed')
      }

      commit('setToken', resp.token)
      // 拉取用户信息与菜单树
      await this.dispatch('fetchUserInfo')
      return resp
    },

    async fetchUserInfo({ commit }) {
      const resp = await request({
        url: '/api/user/info',
        method: 'get'
      })

      if (!resp || resp.code !== 200) {
        throw new Error(resp && resp.msg ? resp.msg : 'Fetch userInfo failed')
      }

      commit('setUserInfo', resp.userInfo)
      commit('setMenuTree', resp.menuTree)
      return resp
    },
    switchLocale({ commit }, locale) {
      setLocale(locale)
      commit('setLocale', locale)
    },
    switchThemeMode({ commit }, mode) {
      commit('setThemeMode', mode)
    },
    updateWorkbench({ commit }, workbench) {
      commit('setWorkbench', workbench)
    },

    logout({ commit }) {
      commit('clearAuth')
    }
  }
})

